import { render, staticRenderFns } from "./opsAfterSales.vue?vue&type=template&id=63483432&scoped=true"
import script from "./opsAfterSales.vue?vue&type=script&lang=js"
export * from "./opsAfterSales.vue?vue&type=script&lang=js"
import style0 from "./opsAfterSales.vue?vue&type=style&index=0&id=63483432&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63483432",
  null
  
)

export default component.exports